import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type GuaranteesInsuranceValues = {
  order?: OrderDetail
}

const GuaranteesInsuranceContext = createContext<GuaranteesInsuranceValues>({})

export const GuaranteesInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<GuaranteesInsuranceValues>) => {
  return (
    <GuaranteesInsuranceContext.Provider value={values}>
      {children}
    </GuaranteesInsuranceContext.Provider>
  )
}

export const useGuaranteesInsuranceValues = () =>
  useContext(GuaranteesInsuranceContext)
